import { AvailableCategories } from '../scripts/AvailableCategories'
import { Sort } from '../scripts/Sorting'

export const CategoryIDs = []

export const CategoryNames = []

const availableCategories = []

for (let cat in AvailableCategories) {
  availableCategories.push(AvailableCategories[cat].id)
}

export const CreateCategories = (theCats,callback) => {

  theCats.map(cat => {
    if(cat.cat_id !== undefined) {
      cat.cat_id.map(id => {
        // get the ones from the correct categories
        if ( availableCategories.includes(id) ) {
          if ( !CategoryIDs.includes(id) ) {
            CategoryIDs.push(id)
          }
        }
      })
    }
  })

  CategoryIDs.map(c => {
    let myLink = []
    myLink.push(c)
    AvailableCategories.map(avail => {
      if ( avail.id === c ) {
        myLink.push(avail.name)
      }
    })
    CategoryNames.push(myLink)
  })

  Sort(CategoryNames)

  callback(CategoryNames)

}
